var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"m-ptr-anchor"},[_c('div',{ref:"indicator",staticClass:"m-ptr",class:{ 'is-ready': _vm.ready, 'is-spinning': _vm.spinning },style:(_vm.indicatorStyle),attrs:{"aria-hidden":"true"}},[(_vm.spinning)?_c('i',{staticClass:"fas fa-sync-alt fa-spin"}):_c('i',{staticClass:"fas fa-arrow-down",style:(_vm.arrowStyle)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }